function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_19764",
  "data-name": "Group 19764",
  transform: "translate(158.043 728.002)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16942",
  "data-name": "Group 16942",
  transform: "translate(996.106 266.638)",
  opacity: 0.294
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_16960",
  "data-name": "Group 16960",
  transform: "translate(930.478 307.437)",
  opacity: 0.19
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2778",
  "data-name": "Ellipse 2778",
  transform: "translate(1028.128 330.313)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.16
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2779",
  "data-name": "Ellipse 2779",
  transform: "translate(1036.568 276.574)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.17
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2780",
  "data-name": "Ellipse 2780",
  transform: "translate(923.026 328.184)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.294
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_2216",
  "data-name": "Line 2216",
  x2: 31.609,
  transform: "translate(1019.775 297.921)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2217",
  "data-name": "Line 2217",
  x2: 33.988,
  transform: "translate(1019.435 307.437)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_19763",
  "data-name": "Group 19763",
  transform: "translate(135.043 240.291)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18022",
  "data-name": "Group 18022",
  transform: "translate(976.529 763.489)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_57",
  "data-name": "Union 57",
  d: "M41.263,35.145V27.257a2.677,2.677,0,0,0-1.549-2.468,30.8,30.8,0,0,0-12.782-2.8h-.121c-.274,0-.56.007-.857.013V19.357c.294-.013.583-.013.865-.013a34.173,34.173,0,0,1,14.025,3.038,5.4,5.4,0,0,1,3.077,4.875v7.888a1.33,1.33,0,0,1-2.659,0Zm-33.273,0V27.257a5.382,5.382,0,0,1,3.071-4.875,34.176,34.176,0,0,1,14.028-3.038c.283,0,.571.007.865.013V22c-.3-.006-.583-.006-.862-.006h-.121a30.839,30.839,0,0,0-12.782,2.792,2.677,2.677,0,0,0-1.543,2.468v7.888a1.328,1.328,0,0,1-2.656,0ZM15.782,9.282A9.314,9.314,0,1,1,25.1,18.563,9.3,9.3,0,0,1,15.782,9.282Zm2.662.1A6.655,6.655,0,1,0,25.1,2.756,6.641,6.641,0,0,0,18.444,9.386Z",
  transform: "translate(0)",
  fill: "#202f43",
  opacity: 0.552
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_31039",
  "data-name": "Path 31039",
  d: "M3.148,14.09a.462.462,0,0,1-.65-.514l.723-4.1L.152,6.56A.482.482,0,0,1,.4,5.736l4.266-.6,1.9-3.755a.448.448,0,0,1,.807,0l1.9,3.755,4.266.6a.482.482,0,0,1,.247.824L10.72,9.472l.723,4.1a.462.462,0,0,1-.65.514L6.969,12.133,3.147,14.09Z",
  transform: "translate(-0.003 -1.123)",
  fill: "#fe8585",
  opacity: 0.552
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "star",
  d: "M26.234,10.86a2.127,2.127,0,0,0-1.69-1.444l-6.089-.985L15.633,2.966a2.142,2.142,0,0,0-3.8,0L9.008,8.431,2.92,9.416a2.128,2.128,0,0,0-1.174,3.6L6.09,17.381l-.941,6.073A2.135,2.135,0,0,0,8.225,25.68l5.507-2.768L19.24,25.68a2.136,2.136,0,0,0,3.076-2.226l-.941-6.073,4.344-4.363a2.116,2.116,0,0,0,.515-2.158Zm-1.709.979L19.584,16.8l1.07,6.908a.455.455,0,0,1-.657.476l-6.264-3.149L7.468,24.186a.455.455,0,0,1-.657-.476L7.88,16.8,2.939,11.839a.455.455,0,0,1,.251-.77l6.925-1.122,3.21-6.216a.457.457,0,0,1,.812,0l3.21,6.216,6.925,1.122a.455.455,0,0,1,.251.77Z",
  transform: "translate(1124.379 1032.46)",
  fill: "#fe8585"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_31038",
  "data-name": "Path 31038",
  d: "M3.148,14.09a.462.462,0,0,1-.65-.514l.723-4.1L.152,6.56A.482.482,0,0,1,.4,5.736l4.266-.6,1.9-3.755a.448.448,0,0,1,.807,0l1.9,3.755,4.266.6a.482.482,0,0,1,.247.824L10.72,9.472l.723,4.1a.462.462,0,0,1-.65.514L6.969,12.133,3.147,14.09Z",
  transform: "translate(-0.003 -1.123)",
  fill: "#fe8585",
  opacity: 0.552
});

function SvgStop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.398,
    height: 71.128,
    viewBox: "0 0 130.398 71.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "good_news",
    "data-name": "good news",
    transform: "translate(-1081.068 -994.64)"
  }, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "star-fill",
    transform: "translate(1151.491 1043.552)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _ref4), _ref5, /*#__PURE__*/React.createElement("g", {
    id: "star-fill-2",
    "data-name": "star-fill",
    transform: "translate(1111.572 1043.552)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _ref6)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.ac5575d5.svg";
export { ForwardRef as ReactComponent };